export enum FontFamily {
  Montserrat = 'Montserrat, Verdana, sans-serif',
}
